export default __webpack_public_path__ + "45f59b54f889842587e17aab236b5fa4.svg";